"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generateTestIdProps;
var _generateTestId = _interopRequireDefault(require("./generateTestId"));
/**
 * @typedef { object } TestIdObject
 * @property { string } data-testid - generated id for component
 */

/**
 * This function generates props for html element in correct format
 * @example
 * const generateTestId = generateTestIdProps({ team, project });
 * return (<button {...generateTestId('my-button')}>Button</Button>);
 * @param { TestIdContext } props
 * @returns { generateTestIdProps~generateTestIdObjectFunction } generator function
 */
function generateTestIdProps({
  team,
  project
}) {
  const getTestId = (0, _generateTestId.default)({
    team,
    project
  });

  /**
   * @callback generateTestIdProps~generateTestIdObjectFunction
   * @param {string} testId - component name
   * @returns { TestIdObject }
   */
  return testId => ({
    'data-testid': getTestId(testId)
  });
}
